import getConfig from "next/config"

const runtimeConfig = getConfig()
const config = runtimeConfig?.publicRuntimeConfig || {}
const appENV = config?.appENV

export default appENV